"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  code: "GE",
  title: "Gestão de Estoques"
}, {
  code: "GF",
  title: "Gestão Financeira"
}, {
  code: "CR",
  title: "CRM Integrado"
}, {
  code: "SN",
  title: "Sistema em Nuvem"
}, {
  code: "IV",
  title: "Integração com Vendas Online"
}, {
  code: "FS",
  title: "Faturamento de Serviços"
}, {
  code: "PF",
  title: "Programas de Fidelidade Nativos"
}, {
  code: "IB",
  title: "Internet Banking Integrado"
}, {
  code: "FC",
  title: "Faturamento pelo Celular ou Tablet"
}, {
  code: "SL",
  title: "Sistema líder no segmento varejo"
}, {
  code: "PD",
  title: "PDV completo frente de loja"
}, {
  code: "AP",
  title: "Atendimento Personalizado"
}];
export default function FuncionalidadesQueGeramResultados() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="funcionalidades-que-geram-resultados" className="bg-background py-20">
      <style>{`
        :root {
          --fume-bg: hsla(0, 0%, 15%, 0.7);
          --background: var(--fume-bg);
        }
        .dark {
          --background: var(--fume-bg);
        }
        section, .card, .popover, .modal, .bg-card, .bg-popover, .bg-background, .bg-section, .bg-modal {
          background-color: var(--fume-bg) !important;
          backdrop-filter: blur(12px) !important;
        }
        section *, .card *, .popover *, .modal * {
          color: var(--foreground);
        }
      `}</style>
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="text-foreground text-3xl font-bold tracking-tight sm:text-4xl">
            Funcionalidades que Geram Resultados
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Tecnologia de ponta para gestão de franquias e varejo, integrada para impulsionar sua lucratividade, otimizar processos e garantir escala operacional para o seu negócio.
          </p>
        </div>

        <div ref={gridRef} className={`mt-16 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-4 lg:grid-cols-6 transition-all duration-1000 delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {features.map((feature, i) => <Card key={i} data-index={i} className="card border-border bg-card hover:border-primary/50 hover:shadow-md group flex h-full flex-col items-center justify-center text-center transition-all duration-300">
              <CardContent className="flex flex-col items-center justify-center p-6">
                <div className="bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground mb-4 flex size-12 shrink-0 items-center justify-center rounded-full text-lg font-bold transition-colors duration-300">
                  {feature.code}
                </div>
                <h3 className="text-foreground text-[14px] font-medium leading-tight">
                  {feature.title}
                </h3>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}